@if(viewerType == 'word'){
  <div class="modal-body d-flex justify-content-center align-items-center">
    <div id="word-container"></div>
</div>


}

@if(viewerType == 'excel'){
<div class="modal-body d-flex justify-content-center align-items-center">
  <div id="excel-container" style="width:100%; height:600px;"></div>
</div>
}

@if(viewerType == 'iframe'){
<div class="modal-body d-flex justify-content-center align-items-center">
  <iframe [src]="fileURL" class="iframe-centered" frameborder="0"></iframe>
</div>
}